import { useQuery, useQueryClient } from '@tanstack/react-query';
import { aivaApi } from 'src/services';
import { Call } from 'src/models';

export type UseGetCallDetailParams = {
  callId: string;
};

export type GetCallDetailResponse = {
  call: Call;
};

export const useGetCallDetails = (params: UseGetCallDetailParams) => {
  const { callId } = params;
  return useQuery({
    queryKey: ['callDetails', params],
    queryFn: () =>
      aivaApi
        .get<GetCallDetailResponse>(`/call/${callId}`)
        .then((res) => res.data.call),
    enabled: !!callId,
  });
};

export const useCallDetailsClient = () => {
  const queryClient = useQueryClient();

  const updateCallDetails = (call: Call) => {
    queryClient.setQueriesData<ReturnType<typeof useGetCallDetails>['data']>(
      { queryKey: ['callDetails'] },
      (oldData) => {
        if (!oldData) return oldData;
        return oldData.call_id === call.call_id ? call : oldData;
      }
    );
  };

  return {
    updateCallDetails,
  };
};
